import { useEffect, useRef, useState } from "react";

export const useInView = (options) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  const rootMargin = options?.rootMargin ?? "300px";
  const threshold = options?.threshold ?? 0;
  const root = options?.root ?? null;

  useEffect(() => {
    const node = ref.current;
    if (!node || inView) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true);
        observer.disconnect();
      }
    }, { rootMargin, threshold, root });

    observer.observe(node);
    return () => observer.disconnect();
  }, [rootMargin, threshold, root, inView]);

  return { ref, inView };
};
